import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const addSensitivePropertyGroup =
  (groupName: string, attributeIris: string[] = []) =>
  (model: Model) => {
    const existingAttributeIris =
      model.modelData.sensitivePropertyGroupsByName[groupName];

    if (existingAttributeIris) {
      return;
    }

    // check that all attributeIris are valid
    const validAttributeIris = attributeIris.filter((iri) =>
      Boolean(model.modelData.attributesByIri[iri])
    );

    setDataProperty<ModelData>(model)(
      model.modelData,
      'sensitivePropertyGroupsByName',
      {
        ...model.modelData.sensitivePropertyGroupsByName,
        [groupName]: [...validAttributeIris],
      }
    );
  };
